import { USER_PROFILE_DEFAULT_NAME } from '@shared/constants/constants';
import type { FederatedUserProfile } from '@shared/services/personalHealth/types/getFederatedUserProfile.types';
import type { ProfileFull } from '@shared/types/user.types';

const getDisplayName = (userProfile?: FederatedUserProfile | null | ProfileFull, skipFallback = false) => {
  if (!userProfile) return skipFallback ? '' : USER_PROFILE_DEFAULT_NAME;

  if ('DisplayName' in userProfile && userProfile.DisplayName) {
    return userProfile.DisplayName;
  }

  if ('Name' in userProfile && userProfile.Name) {
    return userProfile.Name;
  }

  return skipFallback ? '' : USER_PROFILE_DEFAULT_NAME;
};

export { getDisplayName };
